import { createContext } from "react";

// Shared context for both Traditional Raffle and Instant Win View Winners pages
export const ViewWinnerContext = createContext();
